import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import axiosInstance from '../axiosConfig';
import moment from 'moment';
import Header from '../Components/Header';
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import Sidebar from '../Components/Sidebar';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles.css';

Chart.register(...registerables);

const AdminManagerTeamLeadDashboard = () => {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState({}); 
  const [currentUserId] = useState(localStorage.getItem('id')); 
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [leaveRequestsCount, setLeaveRequestsCount] = useState(0);
  const [pendingLeavesCount, setPendingLeavesCount] = useState(0);
  const [approvedLeavesCount, setApprovedLeavesCount] = useState(0);
  const [rejectedLeavesCount, setRejectedLeavesCount] = useState(0);
  const [cancelledLeavesCount, setCancelledLeavesCount] = useState(0);
  const [arRequests, setArRequests] = useState([]);
  const [arRequestsCount, setArRequestsCount] = useState(0); 
  const [pendingArRequestsCount, setPendingArRequestsCount] = useState(0);
  const [approvedArRequestsCount, setApprovedArRequestsCount] = useState(0);
  const [rejectedArRequestsCount, setRejectedArRequestsCount] = useState(0);
  const [cancelledArRequestsCount, setCancelledArRequestsCount] = useState(0);
  const [assignedEmployees, setAssignedEmployees] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [filterType, setFilterType] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTermMyTeam, setSearchTermMyTeam] = useState('');
  const [roles, setRoles] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [queries, setQueries] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [units, setUnits] = useState([]);
  const [branchActiveCount, setBranchActiveCount] = useState(0);
  const [branchInactiveCount, setBranchInactiveCount] = useState(0);
  const [unitActiveCount, setUnitActiveCount] = useState(0);
  const [officeBranchSearch, setOfficeBranchSearch] = useState('');
  const [unitSearch, setUnitSearch] = useState('');

  // Leave Accrual State
  const [showAccrual, setShowAccrual] = useState(false);
  const [accrualLoading, setAccrualLoading] = useState(false);
  const [showResultsModal, setShowResultsModal] = useState(false);
  const [accrualResults, setAccrualResults] = useState('');
  const [dryRun, setDryRun] = useState(true);
  const [selectedBranchId, setSelectedBranchId] = useState('');

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i); 
  const months = [
    { value: '01', label: 'January' }, { value: '02', label: 'February' },
    { value: '03', label: 'March' }, { value: '04', label: 'April' },
    { value: '05', label: 'May' }, { value: '06', label: 'June' },
    { value: '07', label: 'July' }, { value: '08', label: 'August' },
    { value: '09', label: 'September' }, { value: '10', label: 'October' },
    { value: '11', label: 'November' }, { value: '12', label: 'December' },
  ];
  
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    setIsSidebarVisible(screenWidth >= 520);
  }, []);

  const handleToggleClick = () => setIsSidebarVisible(!isSidebarVisible);

  useEffect(() => {
    axiosInstance.get('/user/')
      .then(response => {
        setUsers(response.data);
        axiosInstance.get(`/user/${currentUserId}/`)
          .then(res => {
            const userData = res.data;
            setCurrentUser({ ...userData, role: userData.role?.name || userData.role?.[0]?.name || 'guest' });
          })
          .catch(console.error);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    axiosInstance.get(`/users/${currentUserId}/roles/`)
      .then(res => {
        setRoles([res.data.active_role, res.data.assigned_role]);
      })
      .catch(console.error);
  }, []);

  const handleSwitchRole = async () => {
    try {
      await axiosInstance.post('/switch-role/', { role_id: roles[1].id });
      navigate('/user-dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to switch role");
    }
  };

  useEffect(() => {
    if (!['admin', 'manager', 'team_lead'].includes(currentUser?.role)) return;
    
    axiosInstance.get("/all-leave-requests/")
      .then(res => {
        const data = res.data;
        setLeaveRequestsCount(data.length);
        setPendingLeavesCount(data.filter(lr => lr.status === 'pending').length);
        setApprovedLeavesCount(data.filter(lr => lr.status === 'approved').length);
        setRejectedLeavesCount(data.filter(lr => lr.status === 'rejected').length);
        setCancelledLeavesCount(data.filter(lr => lr.status === 'cancelled').length);
      }).catch(console.error);

    axiosInstance.get("/all-ar-requests/")
      .then(res => {
        const data = res.data;
        setArRequestsCount(data.length);
        setPendingArRequestsCount(data.filter(ar => ar.status === 'pending').length);
        setApprovedArRequestsCount(data.filter(ar => ar.status === 'approved').length);
        setRejectedArRequestsCount(data.filter(ar => ar.status === 'rejected').length);
        setCancelledArRequestsCount(data.filter(ar => ar.status === 'cancelled').length);
      }).catch(console.error);

    axiosInstance.get("/manager-leave-requests/").then(res => setLeaveRequests(res.data)).catch(console.error);
    axiosInstance.get("/attendance-regularization-requests/").then(res => setArRequests(res.data)).catch(console.error);
    axiosInstance.get('/assigned-employees/').then(res => setAssignedEmployees(res.data)).catch(console.error);
    axiosInstance.get('/manager-attendance/').then(res => setAttendance(res.data)).catch(console.error);
  }, [currentUser?.role]);

  useEffect(() => {
    if (currentUser?.role === 'admin' || currentUser?.role === 'manager') {
      axiosInstance.get('/user/').then(res => setUsers(res.data)).catch(console.error);
      axiosInstance.get('/get-attendance/').then(res => setAttendance(res.data)).catch(console.error);
    }
  }, [currentUser?.role]);

  useEffect(() => {
    axiosInstance.get('/queries/').then(res => setQueries(res.data)).catch(console.error);
    axiosInstance.get("/office-branch/").then(res => setLocations(res.data)).catch(console.error);
    axiosInstance.get("/branch-unit/").then(res => setUnits(res.data)).catch(console.error);
  }, []);



  const filteredEmployees = users.filter(u => u.is_active).filter(e => 
    `${e.first_name} ${e.last_name}`.toLowerCase().includes(searchTerm.toLowerCase()) || 
    e.employee_code.toLowerCase().includes(searchTerm.toLowerCase())
  ).sort((a, b) => a.employee_code.localeCompare(b.employee_code));

  const filteredMyTeam = assignedEmployees.filter(u => u.is_active).filter(e => 
    `${e.first_name} ${e.last_name}`.toLowerCase().includes(searchTermMyTeam.toLowerCase()) || 
    e.employee_code.toLowerCase().includes(searchTermMyTeam.toLowerCase())
  ).sort((a, b) => a.employee_code.localeCompare(b.employee_code));

  const filteredUsers = selectedLocation ? users.filter(u => u.is_active && u.work_location === selectedLocation.id) : [];

  const leaveRequestsData = {
    labels: ['Approved', 'Pending', 'Rejected'],
    datasets: [{
      data: [approvedLeavesCount, pendingLeavesCount, rejectedLeavesCount],
      backgroundColor: ['rgba(34, 197, 94, 0.8)', 'rgba(59, 130, 246, 0.8)', 'rgba(239, 68, 68, 0.8)'],
      borderRadius: 6,
    }],
  };
  
  const arRequestsData = {
    labels: ['Approved', 'Pending', 'Rejected'],
    datasets: [{
      data: [approvedArRequestsCount, pendingArRequestsCount, rejectedArRequestsCount],
      backgroundColor: ['rgba(34, 197, 94, 0.8)', 'rgba(59, 130, 246, 0.8)', 'rgba(239, 68, 68, 0.8)'],
      borderRadius: 6,
    }],
  };

  const chartOptions = { 
    indexAxis: 'y', 
    responsive: true, 
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { x: { beginAtZero: true } }
  };

  const getRedirectUrl = (request) => request.type === 'leave' ? `/leave-decision/${request.id}` : '/all-requests/';

  const downloadCSV = async () => {
    if (!selectedYear || !selectedMonth) return alert("Please select both year and month.");
    try {
      const res = await axiosInstance.get(`/attendance/csv/${selectedYear}-${selectedMonth}/`, { responseType: 'blob' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([res.data]));
      link.download = `attendance_${selectedYear}-${selectedMonth}.csv`;
      link.click();
    } catch (err) {
      setErrorMessage("No attendance records found.");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  // Accrual Functions
  const handleAccrueLeaves = async () => {
    if (accrualLoading) return;
    
    setAccrualLoading(true);
    try {
      const payload = { dry_run: dryRun };
      if (selectedBranchId) {
        payload.branch_id = parseInt(selectedBranchId);
      }
      
      const response = await axiosInstance.post('/accrue-leaves/', payload);
      
      setAccrualResults(response.data.output || 'Success');
      setShowResultsModal(true);
      
      toast.success(dryRun ? 'Preview completed!' : 'Leaves accrued successfully!');
      
      // Refresh data
      if (!dryRun && currentUser.role === 'admin') {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error || error.message || 'Failed to process accrual';
      setAccrualResults(errorMsg);
      setShowResultsModal(true);
      toast.error('Accrual failed');
    } finally {
      setAccrualLoading(false);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(accrualResults);
      toast.success('Copied to clipboard!');
    } catch {
      toast.error('Failed to copy');
    }
  };

  const updateQueryStatus = async (id, status) => {
    try {
      await axiosInstance.patch(`/queries/${id}/update-status/`, { status });
      toast.success('Updated!');
    } catch { toast.error('Error!'); }
  };

  return (
    <div className={`dashboard-wrapper ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Header onToggleClick={handleToggleClick} isSidebarVisible={isSidebarVisible} />
      <Sidebar isSidebarVisible={isSidebarVisible} currentUser={currentUser} activeRole={currentUser.role} error={error} handleSwitchRole={handleSwitchRole} handleLogout={handleLogout} />
      
      <main className="dashboard-main-content">
        <div className="dashboard-header-section">
          <h1>Welcome back, {currentUser.first_name || 'User'}! 👋</h1>
          <p>Here's what's happening with your team today.</p>
        </div>

        {/* Stats Row */}
        <div className="stats-grid">
          <div className="stat-card approved">
            <div className="stat-icon-wrapper"><span>✓</span></div>
            <div className="stat-content">
              <span className="stat-number">{approvedLeavesCount + approvedArRequestsCount}</span>
              <span className="stat-label">Approved</span>
            </div>
          </div>
          <div className="stat-card pending">
            <div className="stat-icon-wrapper"><span>⏳</span></div>
            <div className="stat-content">
              <span className="stat-number">{pendingLeavesCount + pendingArRequestsCount}</span>
              <span className="stat-label">Pending</span>
            </div>
          </div>
          <div className="stat-card rejected">
            <div className="stat-icon-wrapper"><span>✕</span></div>
            <div className="stat-content">
              <span className="stat-number">{rejectedLeavesCount + rejectedArRequestsCount}</span>
              <span className="stat-label">Rejected</span>
            </div>
          </div>
          <div className="stat-card cancelled">
            <div className="stat-icon-wrapper"><span>🚫</span></div>
            <div className="stat-content">
              <span className="stat-number">{cancelledLeavesCount + cancelledArRequestsCount}</span>
              <span className="stat-label">Cancelled</span>
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="dashboard-grid">
          {/* Team Attendance */}
          {(currentUser.role === 'manager' || currentUser.role === 'team_lead' || currentUser.role === 'admin') && (
            <div className="dashboard-card full-width">
              <div className="card-header">
                <div className="header-left">
                  <span className="card-icon">📅</span>
                  <div>
                    <h3>My Team Attendance</h3>
                    <p>{moment().format('dddd, MMMM Do, YYYY')}</p>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-scroll">
                  <table className="data-table">
                    <thead>
                      <tr><th>Emp. Code</th><th>Name</th><th>Status</th><th>Punch In</th><th>Punch Out</th></tr>
                    </thead>
                    <tbody>
                      {assignedEmployees.filter(e => e.is_active).sort((a,b) => a.employee_code.localeCompare(b.employee_code)).map(emp => {
                        const att = attendance.find(a => a.user === emp.id && moment(a.date).isSame(moment(), 'day'));
                        return (
                          <tr key={emp.id}>
                            <td>{emp.employee_code}</td>
                            <td><Link to={`/employee-calendar/${emp.id}`}>{emp.first_name} {emp.last_name}</Link></td>
                            <td>{att?.status || '—'}</td>
                            <td>{att?.punch_in_time ? moment(att.punch_in_time, 'HH:mm:ss.SSSSSS').format('hh:mm A') : '—'}</td>
                            <td>{att?.punch_out_time ? moment(att.punch_out_time, 'HH:mm:ss.SSSSSS').format('hh:mm A') : '—'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}


          {/* Work Location */}
          {(currentUser.role === 'admin' || currentUser.role === 'manager') && (
            <div className="dashboard-card">
              <div className="card-header">
                {!selectedLocation ? (
                  <>
                    <span className="card-icon">📍</span>
                    <h3>Work Locations</h3>
                  </>
                ) : (
                  <div className="header-left">
                    <span className="card-icon">📍</span>
                    <div>
                      <h3>{moment().format('dddd, MMMM Do, YYYY')}</h3>
                      <p>Attendance - {selectedLocation.name}</p>
                    </div>
                  </div>
                )}
              </div>
              <div className="card-body">
                {!selectedLocation ? (
                  <div className="location-grid">
                    {locations.map(loc => (
                      <div key={loc.id} className="location-card" onClick={() => setSelectedLocation(loc)}>
                        <span className="loc-unit">{loc.unit_name || loc.unit}</span>
                        <span className="loc-name">{loc.name}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>
                    <div className="back-date-row">
                      <button className="back-btn" onClick={() => setSelectedLocation(null)}>← Back</button>
                      <input
                        type="date"
                        className="date-input"
                        value={selectedDate}
                        onChange={e => setSelectedDate(e.target.value)}
                      />
                    </div>


                    <div className="filter-row">
                      {/* <div className="download-group">
                        <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)}>
                          <option value="">Year</option>
                          {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                        <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}>
                          <option value="">Month</option>
                          {months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                        </select>
                        <button className="action-btn" onClick={downloadCSV}>Download</button>
                      </div> */}
                    </div>
                    <div className="table-scroll">
                      <table className="data-table">
                        <thead><tr><th>Code</th><th>Name</th><th>Status</th><th>In</th><th>Out</th></tr></thead>
                        <tbody>
                          {filteredUsers.sort((a,b) => a.employee_code.localeCompare(b.employee_code)).map(emp => {
                            const att = attendance.find(a => a.user === emp.id && moment(a.date).isSame(selectedDate || moment(), 'day'));
                            return (
                              <tr key={emp.id}>
                                <td>{emp.employee_code}</td>
                                <td><Link to={`/employee-calendar/${emp.id}`}>{emp.first_name} {emp.last_name}</Link></td>
                                <td>{att?.status || '—'}</td>
                                <td>{att?.punch_in_time ? moment(att.punch_in_time, 'HH:mm:ss.SSSSSS').format('hh:mm A') : '—'}</td>
                                <td>{att?.punch_out_time ? moment(att.punch_out_time, 'HH:mm:ss.SSSSSS').format('hh:mm A') : '—'}</td>
                              </tr>
                            );

                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Need to Act */}
          <div className="dashboard-card">
            <div className="card-header">
              <span className="card-icon">🔔</span>
              <h3>Need To Act</h3>
            </div>
            <div className="card-body">
              <div className="filter-bar">
                <select value={filterType} onChange={e => setFilterType(e.target.value)}>
                  <option value="">All</option>
                  <option value="leave">Leave</option>
                  <option value="ar">AR</option>
                </select>
              </div>
              <div className="table-scroll">
                <table className="data-table">
                  <thead><tr><th>Date</th><th>Type</th><th>From</th><th>Status</th></tr></thead>
                  <tbody>
                    {[...leaveRequests.map(r => ({...r, type: 'leave'})), ...arRequests.map(r => ({...r, type: 'ar'}))]
                      .filter(r => filterType === '' ? r.status === 'pending' : r.type === filterType && r.status === 'pending')
                      .map(r => (
                        <tr key={r.id}>
                          <td>{moment(r.created_at).format('MMM DD')}</td>
                          <td>{r.type === 'leave' ? 'Leave' : 'AR'}</td>
                          <td>{r.user_name}</td>
                          <td><Link to={getRedirectUrl(r)} className="status-link">{r.status}</Link></td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Leave Accrual - Admin/Manager Only */}
          {/* {(currentUser.role === 'admin' || currentUser.role === 'manager') && (
            <div className="dashboard-card accrual-card">
              <div className="card-header accrual-header">
                <span className="accrual-icon">📈</span>
                <h3>Leave Accrual</h3>
              </div>
              <div className="accrual-body">
                {showAccrual ? (
                  <div className="accrual-form">
                    <div className="accrual-form-row">
                      <div className="form-group">
                        <label className="form-label">Branch (Optional)</label>
                        <select 
                          value={selectedBranchId} 
                          onChange={(e) => setSelectedBranchId(e.target.value)}
                          className="form-select"
                        >
                          <option value="">All Branches</option>
                          {locations.map(loc => (
                            <option key={loc.id} value={loc.id}>
                              {loc.name} ({loc.unit_name || 'N/A'})
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Dry Run (Preview)</label>
                        <label className="form-checkbox">
                          <input 
                            type="checkbox" 
                            checked={dryRun}
                            onChange={(e) => setDryRun(e.target.checked)}
                          />
                          <span>Preview changes only</span>
                        </label>
                      </div>
                    </div>
                    <div className="accrual-buttons">
                      <button 
                        className="btn-secondary"
                        onClick={() => setShowAccrual(false)}
                        disabled={accrualLoading}
                      >
                        Cancel
                      </button>
                      <button 
                        className="btn-primary"
                        onClick={handleAccrueLeaves}
                        disabled={accrualLoading}
                      >
                        {accrualLoading ? (
                          <span className="loading-text">
                            <span className="spinner-small"></span>
                            Processing...
                          </span>
                        ) : dryRun ? (
                          'Preview Accrual'
                        ) : (
                          'Execute Accrual'
                        )}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                    <span style={{ fontSize: '48px', display: 'block', marginBottom: '16px' }}>📅</span>
                    <h4 style={{ color: '#1e293b', marginBottom: '8px' }}>Monthly Leave Accrual</h4>
                    <p style={{ color: '#64748b', marginBottom: '24px', fontSize: '14px' }}>
                      Add monthly leave balances for active employees. 
                      Run on 1st of every month. Resets SL on April 1st.
                    </p>
                    <button 
                      className="btn-primary" 
                      onClick={() => setShowAccrual(true)}
                      style={{ padding: '12px 32px', fontSize: '15px' }}
                    >
                      Configure & Run
                    </button>
                  </div>
                )}
              </div>
            </div>
          )} */}

          {/* Office Branches Table */}
          <div className="dashboard-card">
            <div className="card-header">
              <span className="card-icon">📍</span>
              <h3>Office Branches</h3>
              <Link to="/roles-office" className="add-btn" style={{fontSize: '12px'}}>View All →</Link>
            </div>
            <div className="card-body">
              <div className="filter-bar">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search branches..."
                  value={officeBranchSearch}
                  onChange={(e) => setOfficeBranchSearch(e.target.value)}
                />
              </div>
              <div className="table-scroll">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Unit</th>
                      <th>Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {locations
                      .filter(location => 
                        location.name.toLowerCase().includes(officeBranchSearch.toLowerCase()) ||
                        (location.unit_name || '').toLowerCase().includes(officeBranchSearch.toLowerCase())
                      )
                      .slice(0, 3)
                      .map(location => (
                      <tr key={location.id}>
                        <td>{location.unit_name || '—'}</td>
                        <td>{location.name}</td>
                        <td>
                          <span className={`status-badge ${location.status === 'active' ? 'approved' : 'rejected'}`}>
                            {location.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Today's Attendance Summary Chart */}
          <div className="dashboard-card">
            <div className="card-header">
              <span className="card-icon">📊</span>
              <h3>Today's Summary</h3>
              <p>{moment().format('MMM DD, YYYY')}</p>
            </div>
            <div className="card-body chart-body">
              <Bar 
                data={{
                  labels: ['Present', 'Absent'],
                  datasets: [{
                    data: [
                      attendance.filter(a => moment(a.date).isSame(moment(), 'day') && (a.status === 'present' || a.punch_in_time)).length,
                      users.filter(u => u.is_active).length - attendance.filter(a => moment(a.date).isSame(moment(), 'day') && (a.status === 'present' || a.punch_in_time)).length
                    ],
                    backgroundColor: ['rgba(34, 197, 94, 0.8)', 'rgba(239, 68, 68, 0.8)'],
                    borderRadius: 8,
                    borderSkipped: false,
                  }]
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: { legend: { display: false } },
                  scales: {
                    y: { 
                      beginAtZero: true,
                      ticks: { stepSize: 1 }
                    }
                  }
                }}
              />
            </div>
          </div>

          {/* Employees List */}
          {(currentUser.role === 'admin' || currentUser.role === 'manager') && (
            <>
              <div className="dashboard-card">
                <div className="card-header">
                  <span className="card-icon">👥</span>
                  <h3>Employees</h3>
                </div>
                <div className="card-body">
                  <input type="text" placeholder="Search..." className="search-input" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                  <div className="people-list">
                    {filteredEmployees.filter(e => e.is_active).slice(0, 8).map(emp => (
                      <div key={emp.id} className="person-item">
                        <div className="person-avatar">{emp.first_name?.[0]}{emp.last_name?.[0]}</div>
                        <div className="person-info"><span className="person-name">{emp.first_name} {emp.last_name}</span><span className="person-code">{emp.employee_code}</span></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="dashboard-card">
                <div className="card-header">
                  <span className="card-icon">👥</span>
                  <h3>My Team</h3>
                </div>
                <div className="card-body">
                  <input type="text" placeholder="Search..." className="search-input" value={searchTermMyTeam} onChange={e => setSearchTermMyTeam(e.target.value)} />
                  <div className="people-list">
                    {filteredMyTeam.filter(e => e.is_active).slice(0, 8).map(emp => (
                      <div key={emp.id} className="person-item">
                        <div className="person-avatar">{emp.first_name?.[0]}{emp.last_name?.[0]}</div>
                        <div className="person-info"><span className="person-name">{emp.first_name} {emp.last_name}</span><span className="person-code">{emp.employee_code}</span></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}

          {currentUser.role === 'team_lead' && (
            <div className="dashboard-card full-width">
              <div className="card-header">
                <span className="card-icon">👥</span>
                <h3>My Team</h3>
              </div>
              <div className="card-body">
                <input type="text" placeholder="Search..." className="search-input" value={searchTermMyTeam} onChange={e => setSearchTermMyTeam(e.target.value)} />
                <div className="table-scroll">
                  <table className="data-table">
                    <thead><tr><th></th><th>Emp. Code</th><th>Name</th></tr></thead>
                    <tbody>
                      {filteredMyTeam.filter(e => e.is_active).map(emp => (
                        <tr key={emp.id}>
                          <td><div className="person-avatar small">{emp.first_name?.[0]}{emp.last_name?.[0]}</div></td>
                          <td>{emp.employee_code}</td>
                          <td>{emp.first_name} {emp.last_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Query FAB */}
        {/* {currentUser.role !== 'team_lead' && (
          <button className="fab-button" onClick={() => setIsPopupVisible(true)}>💬</button>
        )} */}

        {/* Accrual Results Modal */}
        {showResultsModal && (
          <div className="accrual-modal-overlay" onClick={() => setShowResultsModal(false)}>
            <div className="accrual-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3 className="modal-title">
                  {dryRun ? 'Accrual Preview' : 'Accrual Results'}
                </h3>
                <button className="modal-close" onClick={() => setShowResultsModal(false)}>×</button>
              </div>
              <div className="modal-body">
                <div className="modal-output">{accrualResults}</div>
                <button className="copy-btn" onClick={copyToClipboard}>
                  📋 Copy Output
                </button>
              </div>
              <div className="modal-footer">
                <button 
                  className="btn-primary"
                  onClick={() => {
                    setShowResultsModal(false);
                    if (!dryRun) {
                      toast.success('Dashboard refreshing...');
                      setTimeout(() => window.location.reload(), 500);
                    }
                  }}
                >
                  {dryRun ? 'Run for Real' : 'Done'}
                </button>
              </div>
            </div>
          </div>
        )}

        {isPopupVisible && (
          <div className="popup-overlay" onClick={() => setIsPopupVisible(false)}>
            <div className="popup-content" onClick={e => e.stopPropagation()}>
              <div className="popup-header">
                <h4>Queries</h4>
                <button onClick={() => setIsPopupVisible(false)}>✕</button>
              </div>
              <div className="popup-body">
                {queries.filter(q => q.status === 'pending').map((q, i) => (
                  <div key={i} className="query-card">
                    <p><strong>Query:</strong> {q.query}</p>
                    <p><strong>From:</strong> {q.user_name} ({q.employee_code})</p>
                    <button className="resolve-btn" onClick={() => updateQueryStatus(q.id, 'resolved')}>Resolve</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        <ToastContainer />
      </main>
    </div>
  );
};

export default AdminManagerTeamLeadDashboard;
